export default "__VITE_ASSET__rVGYl842__"